import { useCallback } from "react";
import { NavLink, useNavigate } from "react-router-dom";

export default function Navbar({ isLoggedIn }: { isLoggedIn: boolean }) {
	const navigate = useNavigate();

	const logout = useCallback(() => {
		fetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
		}).finally(() => {
			navigate('/login');
		});
	}, []);

	return (
		<div className="navbar" style={{justifyContent: "space-around"}}>
			<NavLink to="/">Home</NavLink>
			<NavLink to="/events" >Events</NavLink>
			<NavLink to="/news" >News</NavLink>
			<NavLink to="/info" >Info</NavLink>
			<NavLink to="/map" >Map</NavLink>
			{!isLoggedIn && <NavLink to="/login">Login</NavLink>}
			{isLoggedIn && <NavLink to="#" onClick={logout}>Logout</NavLink>}
		</div>
	);
}
